import { createContext } from 'react';

export const NeedJumpContext = createContext(false);
